"use client";
import { Image } from "antd";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslations } from "next-intl";
import { Autoplay, Pagination } from "swiper/modules";
import { useEffect, useState } from "react";
const certificates = [
	"/image/examining-report/ffaddf3d583bd9d3f085d2ee4a094fae-1.jpg",
	"/image/examining-report/ROSH2_1745462366013_1.jpg",
	"/image/examining-report/ROSH3_1745462367438_1.jpg",
	"/image/examining-report/减肥CE.png",
	"/image/examining-report/检测3_1745462372039_1.jpg",
	"/image/examining-report/检测4_1745462376647_1.jpg",
	"/image/examining-report/检测5_1745462377052_1.jpg",
	"/image/examining-report/检测证书1_1745462379622_1.jpg",
	"/image/examining-report/检测证书二_1745462379984_1.jpg",
	// "/image/examining-report/",
];
const { PreviewGroup } = Image;
const Certificate = ({ images = [] }: { images: string[] }) => {
	// const t = useTranslations("about");
	const [slidesPerView, setSlidesPerView] = useState(6);
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth <= 768) {
				setSlidesPerView(2);
			} else if (window.innerWidth <= 1024) {
				setSlidesPerView(3); // Update for large devices
			} else {
				setSlidesPerView(6);
			}
		};
		handleResize();
		window.addEventListener("resize", handleResize);
	}, []);

	return (
		<div>
			{/* <h2 className="mb-10 pt-10 text-center text-[40px]"> {t("Certificate")} </h2> */}
			<div className="container">
				<PreviewGroup>
					<Swiper
						pagination={true}
						modules={[Pagination, Autoplay]}
						loop={true}
						slidesPerView={slidesPerView}
						spaceBetween={30}
						autoplay={{
							delay: 5000,
							disableOnInteraction: true,
						}}
					>
						{images.map((item, index) => {
							return (
								<SwiperSlide key={index} className={`relative cursor-pointer rounded transition-all`}>
									<div className="flex h-full items-center">
										<Image src={item} key={index} />
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</PreviewGroup>
			</div>
		</div>
	);
};
export default Certificate;
